import Status from '../Shared/Status';
import { InvoiceStatus } from '@/Components/Invoicing/InvoiceStatus';

export enum DictationLockType {
    OrderProcedureCombination = 0,
    Order = 1,
}

interface WorklistOrderInfo {
    OrderID: number;
    OrderNumber: string;
    SiteID: number | null;
    SiteName: string | null;
    RequestingPhysician: string;
    RequestingPhysicianRemarksPrivate: string | null;
    RequestingPhysicianRemarksPublic: string | null;
    Urgency: WorklistOrderUrgencyInfo | null;
    OrderStatus: Status | null;
    OrderDateTimePrescription: string | null;
    OrderRemarks: string | null;
    InvoiceAmount: number;
    InvoiceStatus: InvoiceStatus | null;
    ReadyForInvoicing: boolean;
    InvoiceEID: number | null;
    ReportID: number | null;
    VisitID: number | null;
    JustificationStatus: number;
}

interface WorklistPatientInfo {
    ID: number;
    FirstName: string | null;
    LastName: string;
    PatientDOB: string;
    PatientAge: number;
    PatientExternalID: string | null;
    PatientNationalNumber: string | null;
    PatientLanguage: string;
    PatientStatus: string;
    PatientOrigin: string | null;
    VisitNumber: string | null;
    UnitOfCare: string | null;
    PatientRemarksPublic: string | null;
    PatientRemarksPrivate: string | null;
    Gender: string | null;
    AdmissionDepartment: string | null;
    PatientLocation: string | null;
}

interface WorklistProcedureInfo {
    Code: string;
    Color: string;
    Description: string;
    ModalityName: string | null;
}

interface WorklistOrderProcedureHallInfo {
    ID: number;
    Name: string;
    Code: string;
}

interface WorklistOrderProcedureRadiologistInfo {
    Id: number;
    Name: string;
    FirstName: string;
}

interface WorklistOrderProcedureTechnicianInfo {
    Id: number;
    Name: string;
}

interface WorklistOrderProcedureInfo {
    OrderProcedureID: number;
    Status: Status;
    AccessionNumber: string;
    ProcedureInfo: WorklistProcedureInfo;
    HallInfo?: WorklistOrderProcedureHallInfo;
    ImplementationDate: Date;
    RadiologistInfo?: WorklistOrderProcedureRadiologistInfo;
    TechnicianInfo?: WorklistOrderProcedureTechnicianInfo;
    ProcedureReportInfo?: WorklistProcedureReportInfo;
    ReportID: number | null;
    DictationLockType?: DictationLockType | null;
    DictationLockedBy?: string | null;
}

interface WorklistOrderReportInfo {
    ReportID: number;
    OrderProcedureIds: number[];
    IsOrderTypeReport: boolean;
    IsLocked: boolean;
    LockedBy: string | null;
    ReportSupervisor: string | null;
    ReportReviewer: string | null;
    ReportValidatedBy: string | null;
    ReportTranscribedBy: string | null;
    ReportCreatedBy: string | null;
    ReportCreatedDateTime: Date | null;
    ReportValidatedDateTime: Date | null;
    Status: number | null;
}
interface WorklistProcedureReportInfo {
    ReportID: number;
}
interface WorklistOrderLabelInfo {
    ID: number;
    Name: string;
    Abbreviation: string;
    TextColor: string;
    BackgroundColor: string;
}

interface WorklistOrderUrgencyInfo {
    ID: number;
    Name: string | null;
    Abbreviation: string | null;
    Color: string | null;
    Number: number | null;
}

interface OrderForWorklist {
    OrderInfo: WorklistOrderInfo;
    PatientInfo: WorklistPatientInfo;
    OrderProceduresInfos: WorklistOrderProcedureInfo[];
    OrderReportsInfos: WorklistOrderReportInfo[];
    OrderLabelsInfos: WorklistOrderLabelInfo[] | null;
    HasRemarks: boolean;
}

interface WorklistResult {
    Orders: OrderForWorklist[];
    Count: number;
    CountOverflow: boolean;
}

type BulkReportingAction = { type: 'dictate'; orderId: number } | { type: 'validate'; orderId: number; reportId: number };

export type {
    WorklistResult,
    WorklistOrderInfo,
    WorklistPatientInfo,
    WorklistProcedureInfo,
    WorklistOrderLabelInfo,
    WorklistOrderProcedureInfo,
    WorklistOrderProcedureHallInfo,
    WorklistOrderUrgencyInfo,
    OrderForWorklist,
    WorklistOrderReportInfo,
    BulkReportingAction,
};
